import { render, staticRenderFns } from "./SystemModel.vue?vue&type=template&id=3af6f89e&scoped=true&"
import script from "./SystemModel.vue?vue&type=script&lang=js&"
export * from "./SystemModel.vue?vue&type=script&lang=js&"
import style0 from "./SystemModel.vue?vue&type=style&index=0&id=3af6f89e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af6f89e",
  null
  
)

export default component.exports